(function ($) {
  "use strict";

  /**
   * Add ArrowRight svg icons to all Subscribe Subscribe buttons on the page
   * Subscribe forms are embed vie Sendblue plugin shortcodes
   * Screenshots: https://i.imgur.com/izKJyjQ.png
   */

  const $subscribeBtns = $(document).find('.hitechSubscribe button');
  const arrowrightSVG = document.querySelector('.svg-arrowright');

  if ($subscribeBtns.length && arrowrightSVG) {
    $subscribeBtns.each(function(i,btn) {
      btn.insertAdjacentElement('afterbegin', arrowrightSVG.cloneNode(true));
    })
  }


  $(document).on('click', '#contactFormBtn', function(e) {
    e.preventDefault(e);

    $('#contactForm').find('input[type="submit"]').click();
  })

})(jQuery);
